import React, { useState, useEffect, Fragment } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Tooltip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from '@material-ui/icons/GetApp';
import AttachmentIcon from '@material-ui/icons/Attachment';
import LinkIcon from '@material-ui/icons/Link';
import { formValues } from "../containers/SrTaskFormData";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import { backendDateFormat, dayMonthDateFormat, fieldDMYShort } from "../../../../constants";
import MomentUtils from "@date-io/moment";
import { addTaskFormApi, deleteAttachment } from "../apiService";
import { checkApiStatus } from "../../../../utils";
import { trackActivity } from '../../../../utils/mixpanel';
import { globalPutService } from "../../../../utils/globalApiServices";
import LinkFiles from "../../../../shared_elements/components/LinkFiles";
import UploadFile from "../../../../shared_elements/components/UploadFile";
import { assetType, imgStoragePath } from "../../../../constants";
import config from "../../../../config";
import { acumenCamo } from "../../../../shared_elements/components";

const SrTaskForm = (props) => {
	const {
		formTitle, actionType, closeAddForm, editFormId, editFormData,
		attachments: propsAttachments, getResponseBack, updateFormData,
		fileUploadData, uuid, last_used_folder_uuid, last_used_folder_uuid_link_document,
		checkbox_last_used_folder_uuid, checkbox_last_used_folder_name,
		headerTsn, headerCsn
	} = props

	const [error, setError] = useState({})
	const [data, setData] = useState(formValues)
	const [attachments, setAttachments] = useState([])
	const [newUploadedAttachments, setNewUploadedAttachments] = useState([])
	const [linkFile, setLinkFile] = useState(false)
	const [uploadFile, setUploadFile] = useState(false)

	useEffect(() => {
		if (editFormId) {
			setAttachments(propsAttachments || [])
			setData(editFormId === undefined || editFormId === null ? {} : editFormData)
		}
		trackActivity('CAMO', {
			event_type: 'Modal Opened',
			page_title: 'Structure Repairs(SR) Add Task Form',
		})
	}, [])

	const buildValidationInputs = (formData) => ({
		ata_chapter: (acumenCamo || formData?.ata_chapter?.trim()) ? "" : "Please enter ATA chapter",
		repair_ref_number: formData?.repair_ref_number?.trim() ? "" : "Please enter ref number",
		repair_description: (acumenCamo || formData?.repair_description?.trim()) ? "" : "Please enter repair description",
		srm_ref_document: (acumenCamo || formData?.srm_ref_document?.trim()) ? "" : "Please enter srm ref document"
	})

	const onFieldChange = (keyParam, value) => {
		setData(prev => ({ ...prev, [keyParam]: value }))
	}

	const onRestErrorKey = (keyParam) => {
		setError(prev => ({ ...prev, [keyParam]: "" }))
	}

	const onFocusValidation = (keyParam) => {
		const validationInputs = buildValidationInputs(data)
		if (validationInputs[keyParam]) {
			setError(prev => ({ ...prev, [keyParam]: validationInputs[keyParam] }))
		}
	}

	const handleSubmit = async (e, currentBtnStatus) => {
		e.preventDefault()
		const validationInputs = buildValidationInputs(data)
		if (Object.keys(validationInputs).every(k => validationInputs[k] === "")) {
			const innerProps = props.props
			let payload = Object.assign({}, data)
			payload = {
				...payload,
				asset_id: innerProps.match.params.asset,
				asset_type_id: innerProps.match.params.assetType,
				last_done_fc: payload.last_done_fc || null,
				last_done_fh: payload.last_done_fh || null,
				dimension_interval_fc: payload.dimension_interval_fc || null,
				dimension_interval_days: payload.dimension_interval_days || null,
				repair_interval: payload.repair_interval || null,
				repair_compliance_tsn: payload.repair_compliance_tsn || null,
				repair_compliance_csn: payload.repair_compliance_csn || null,
			}
			if (editFormId) {
				payload.remaining = { ...(payload.remaining || {}), due_at: payload.repair_DUE, remaining: payload.remaining_val }
				if (payload.repair_status === "CLOSED") {
					delete payload.repair_DUE
					delete payload.remaining_val
				}
				await uploadFileTest(editFormId, innerProps, true, "update")
				await updateFormData(editFormId, payload, innerProps)
				closeAddForm()
				trackActivity('CAMO', {
					event_type: 'Task Updated Successfully',
					page_title: 'Service Repairs(SR)',
					item_id: editFormId || '',
					request_body: payload || ''
				})
			} else {
				delete payload.repair_DUE
				delete payload.remaining_val
				addTaskFormApi(payload, innerProps).then(async (response) => {
					const uploadId = response.data.data.id
					if (uploadId) {
						await uploadFileTest(uploadId, innerProps, false, currentBtnStatus)
						trackActivity('CAMO', {
							event_type: 'Task Added Successfully',
							page_title: 'Service Repairs(SR)',
							item_id: uploadId || '',
							request_body: payload || '',
							response_msg: response.data.message || ''
						})
					}
				})
				if (currentBtnStatus !== "addAnother") {
					closeAddForm()
				}
			}
		} else {
			setError(validationInputs)
			trackActivity('CAMO', {
				event_type: editFormId ? 'Update TASK Failed' : 'Add TASK Failed',
				page_title: 'Service Repairs(SR)',
				error_source: 'Frontend',
				error_type: validationInputs || ''
			})
		}
	}

	const addFormData = (e) => handleSubmit(e, "add")
	const saveAndAddAnother = (e) => handleSubmit(e, "addAnother")

	const uploadFileTest = async (uploadId, innerProps, isUpdate, currentBtnStatus) => {
		if (newUploadedAttachments.length > 0) {
			let formdata = new FormData()
			const module_type_id = 7
			Object.keys(newUploadedAttachments).forEach((key) => {
				formdata.append(`[${key}]file`, newUploadedAttachments[key])
				formdata.append(`[${key}]file_type`, newUploadedAttachments[key].type)
				formdata.append(`[${key}]file_name`, newUploadedAttachments[key].name)
				formdata.append(`[${key}]module_id`, uploadId)
				formdata.append(`[${key}]module_type_id`, module_type_id)
				formdata.append(`[${key}]asset_id`, innerProps.match.params.asset)
				formdata.append(`[${key}]asset_type_id`, innerProps.match.params.assetType)
			})
			fileUploadData(uploadId, formdata, innerProps, true)
			if (currentBtnStatus === "addAnother") {
				resetBothAttachmentArray()
			}
			if (!isUpdate) {
				onSubmitFileLink(uploadId)
				fileUploadData(uploadId, null, innerProps, false)
			}
		} else {
			if (currentBtnStatus === "addAnother") {
				setData(formValues)
				setAttachments([])
				document.getElementById("asset-form").reset()
				fileUploadData(uploadId, null, innerProps, false)
			} else {
				if (!isUpdate) {
					onSubmitFileLink(uploadId)
					fileUploadData(uploadId, null, innerProps, false)
				}
			}
		}
	}

	const resetBothAttachmentArray = () => {
		setData(formValues)
		setAttachments([])
		setNewUploadedAttachments([])
		document.getElementById("asset-form").reset()
	}

	const onUpload = (files) => {
		const chosenFiles = Array.prototype.slice.call(files)
		for (let i = 0; i < chosenFiles.length; i++) {
			if (chosenFiles[i].size > 52428800) {
				props.props.enqueueSnackbar(
					`${chosenFiles[i].name} Maximum file size should be 50MB.`,
					{ variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } }
				)
				delete chosenFiles[i]
			} else {
				handleUploadFiles(chosenFiles)
			}
		}
	}

	const handleUploadFiles = (files) => {
		const uploaded = [...newUploadedAttachments]
		const existingAttachments = [...attachments]
		files.forEach(file => {
			uploaded.push(file)
			existingAttachments.push({
				id: 0,
				module_id: 1,
				module_type_id: 7,
				file_name: file.name,
				file_type: file.type,
				file: "",
				name: file.name,
				asset_id: props.props.match.params.asset,
				asset_type_id: props.props.match.params.assetType
			})
		})
		setNewUploadedAttachments(uploaded)
		setAttachments(existingAttachments)
	}

	const deleteAttachmentFile = async (id, file) => {
		if (id !== undefined && id !== 0) {
			const innerProps = props.props
			deleteAttachment(id, innerProps)
			setAttachments(prev => prev.filter(item => item.id !== id))
		} else {
			onRemoveCamoFile(file)
		}
	}

	const srIsValidNum = (val) => val !== null && val !== undefined && val !== '' && !isNaN(Number(val))
	const srIsValidDate = (date) => !!date && moment(date).isValid()
	const srSafeDecimal = (val) => {
		const n = Number(val)
		if (isNaN(n)) return null
		return Number.isInteger(n) ? n : parseFloat(n.toFixed(2))
	}

	const nextDueValue = () => {
		if (data.repair_status === "CLOSED") {
			if (["FH", "FC", "D", "FH,D", "FC,D", "FC,FH,D", "FC,FH"].includes(data.repair_interval_type)) {
				data.repair_DUE = ""
			}
		} else {
			if (data.repair_interval_type === "FH") {
				if (!srIsValidNum(data.last_done_fh) || !srIsValidNum(data.repair_interval)) return (data.repair_DUE = "")
				data.repair_DUE = srSafeDecimal(+data.last_done_fh + +data.repair_interval)
			} else if (data.repair_interval_type === "FC") {
				if (!srIsValidNum(data.last_done_fc) || !srIsValidNum(data.dimension_interval_fc)) return (data.repair_DUE = "")
				data.repair_DUE = srSafeDecimal(+data.last_done_fc + +data.dimension_interval_fc)
			} else if (data.repair_interval_type === "D") {
				if (!srIsValidDate(data.last_done_date) || !srIsValidNum(data.dimension_interval_days)) return (data.repair_DUE = "")
				data.repair_DUE = moment(data.last_done_date).add(+data.dimension_interval_days, "days").format("DD-MM-YYYY")
			} else if (data.repair_interval_type === "FC,D") {
				if (!srIsValidNum(data.last_done_fc) || !srIsValidNum(data.dimension_interval_fc) || !srIsValidDate(data.last_done_date) || !srIsValidNum(data.dimension_interval_days)) return (data.repair_DUE = "")
				const fcDue = srSafeDecimal(+data.last_done_fc + +data.dimension_interval_fc)
				const dateDue = moment(data.last_done_date).add(+data.dimension_interval_days, "days")
				const fcDueAsMoment = srIsValidNum(headerCsn) ? moment().add(fcDue - +headerCsn, "days") : null
				data.repair_DUE = fcDueAsMoment && dateDue.isBefore(fcDueAsMoment) ? dateDue.format("DD-MM-YYYY") : fcDue
			} else if (data.repair_interval_type === "FH,D") {
				if (!srIsValidNum(data.last_done_fh) || !srIsValidNum(data.repair_interval) || !srIsValidDate(data.last_done_date) || !srIsValidNum(data.dimension_interval_days)) return (data.repair_DUE = "")
				const fhDue = srSafeDecimal(+data.last_done_fh + +data.repair_interval)
				const dateDue = moment(data.last_done_date).add(+data.dimension_interval_days, "days")
				const fhDueAsMoment = srIsValidNum(headerTsn) ? moment().add(fhDue - +headerTsn, "days") : null
				data.repair_DUE = fhDueAsMoment && dateDue.isBefore(fhDueAsMoment) ? dateDue.format("DD-MM-YYYY") : fhDue
			} else if (data.repair_interval_type === "FC,FH,D") {
				if (!srIsValidNum(data.last_done_fh) || !srIsValidNum(data.repair_interval) || !srIsValidNum(data.last_done_fc) || !srIsValidNum(data.dimension_interval_fc) || !srIsValidDate(data.last_done_date) || !srIsValidNum(data.dimension_interval_days)) return (data.repair_DUE = "")
				const fhDue = srSafeDecimal(+data.last_done_fh + +data.repair_interval)
				const fcDue = srSafeDecimal(+data.last_done_fc + +data.dimension_interval_fc)
				const dateDue = moment(data.last_done_date).add(+data.dimension_interval_days, "days")
				const fhDueAsMoment = srIsValidNum(headerTsn) ? moment().add(fhDue - +headerTsn, "days") : null
				const fcDueAsMoment = srIsValidNum(headerCsn) ? moment().add(fcDue - +headerCsn, "days") : null
				if (fhDueAsMoment && fcDueAsMoment) {
					if (fhDueAsMoment.isBefore(fcDueAsMoment) && fhDueAsMoment.isBefore(dateDue)) data.repair_DUE = fhDue
					else if (fcDueAsMoment.isBefore(fhDueAsMoment) && fcDueAsMoment.isBefore(dateDue)) data.repair_DUE = fcDue
					else data.repair_DUE = dateDue.format("DD-MM-YYYY")
				} else {
					data.repair_DUE = ""
				}
			} else if (data.repair_interval_type === "FC,FH") {
				if (!srIsValidNum(data.last_done_fh) || !srIsValidNum(data.repair_interval) || !srIsValidNum(data.last_done_fc) || !srIsValidNum(data.dimension_interval_fc)) return (data.repair_DUE = "")
				const fhDue = srSafeDecimal(+data.last_done_fh + +data.repair_interval)
				const fcDue = srSafeDecimal(+data.last_done_fc + +data.dimension_interval_fc)
				data.repair_DUE = fcDue < fhDue ? fcDue : fhDue
			}
		}
		return data.repair_DUE ?? ""
	}

	const remainingVal = () => {
		if (data.repair_status === "CLOSED") {
			if (["FH", "FC", "D", "FH,D", "FC,D", "FC,FH,D", "FC,FH"].includes(data.repair_interval_type)) {
				data.remaining_val = ""
			}
		} else {
			const today = moment()
			const lastDoneDate = moment(data.last_done_date)

			if (data.repair_interval_type === "D") {
				if (!srIsValidDate(data.last_done_date) || !srIsValidNum(data.dimension_interval_days)) return (data.remaining_val = "")
				data.remaining_val = +data.dimension_interval_days - today.diff(lastDoneDate, "days")
			} else if (data.repair_interval_type === "FC") {
				if (!srIsValidNum(data.last_done_fc) || !srIsValidNum(data.dimension_interval_fc) || !srIsValidNum(headerCsn)) return (data.remaining_val = "")
				data.remaining_val = srSafeDecimal((+data.last_done_fc + +data.dimension_interval_fc) - +headerCsn)
			} else if (data.repair_interval_type === "FH") {
				if (!srIsValidNum(data.last_done_fh) || !srIsValidNum(data.repair_interval) || !srIsValidNum(headerTsn)) return (data.remaining_val = "")
				data.remaining_val = srSafeDecimal((+data.last_done_fh + +data.repair_interval) - +headerTsn)
			} else if (data.repair_interval_type === "FC,D") {
				if (!srIsValidNum(data.last_done_fc) || !srIsValidNum(data.dimension_interval_fc) || !srIsValidNum(headerCsn) || !srIsValidDate(data.last_done_date) || !srIsValidNum(data.dimension_interval_days)) return (data.remaining_val = "")
				const fcRem = srSafeDecimal((+data.last_done_fc + +data.dimension_interval_fc) - +headerCsn)
				const dRem = +data.dimension_interval_days - today.diff(lastDoneDate, "days")
				data.remaining_val = fcRem !== null && fcRem < dRem ? fcRem : dRem
			} else if (data.repair_interval_type === "FH,D") {
				if (!srIsValidNum(data.last_done_fh) || !srIsValidNum(data.repair_interval) || !srIsValidNum(headerTsn) || !srIsValidDate(data.last_done_date) || !srIsValidNum(data.dimension_interval_days)) return (data.remaining_val = "")
				const fhRem = srSafeDecimal((+data.last_done_fh + +data.repair_interval) - +headerTsn)
				const dRem = +data.dimension_interval_days - today.diff(lastDoneDate, "days")
				data.remaining_val = fhRem !== null && fhRem < dRem ? fhRem : dRem
			} else if (data.repair_interval_type === "FC,FH,D") {
				if (!srIsValidNum(data.last_done_fh) || !srIsValidNum(data.repair_interval) || !srIsValidNum(data.last_done_fc) || !srIsValidNum(data.dimension_interval_fc) || !srIsValidNum(headerTsn) || !srIsValidNum(headerCsn) || !srIsValidDate(data.last_done_date) || !srIsValidNum(data.dimension_interval_days)) return (data.remaining_val = "")
				const fhRem = srSafeDecimal((+data.last_done_fh + +data.repair_interval) - +headerTsn)
				const fcRem = srSafeDecimal((+data.last_done_fc + +data.dimension_interval_fc) - +headerCsn)
				const dRem = +data.dimension_interval_days - today.diff(lastDoneDate, "days")
				if (fhRem !== null && fcRem !== null) {
					if (fhRem <= fcRem && fhRem <= dRem) data.remaining_val = fhRem
					else if (fcRem <= fhRem && fcRem <= dRem) data.remaining_val = fcRem
					else data.remaining_val = dRem
				} else {
					data.remaining_val = ""
				}
			} else if (data.repair_interval_type === "FC,FH") {
				if (!srIsValidNum(data.last_done_fh) || !srIsValidNum(data.repair_interval) || !srIsValidNum(data.last_done_fc) || !srIsValidNum(data.dimension_interval_fc) || !srIsValidNum(headerTsn) || !srIsValidNum(headerCsn)) return (data.remaining_val = "")
				const fcRem = srSafeDecimal((+data.last_done_fc + +data.dimension_interval_fc) - +headerCsn)
				const fhRem = srSafeDecimal((+data.last_done_fh + +data.repair_interval) - +headerTsn)
				data.remaining_val = fcRem !== null && fcRem < fhRem ? fcRem : fhRem
			}
		}
		return data.remaining_val ?? ""
	}

	const getResponseBackFn = (file) => {
		setData(prev => ({ ...prev, checklist: file }))
	}

	const listResponseBack = (file) => {
		if (actionType === "add") return null
		getResponseBack(file)
	}

	const onUnlinkCheckListFile = (checklist, fileId) => {
		let payload = {}
		payload.delete = true
		payload.folder_ids = checklist?.folders?.filter(item => item.type === 'folder').map(file => file.id).filter(id => id !== fileId).join(',')
		payload.file_ids = checklist?.files?.filter(item => item.type === 'file').map(file => file.id).filter(id => id !== fileId).join(',')
		globalPutService(`camo/repair/${editFormId}/document-checklists/`, payload).then(response => {
			if (checkApiStatus(response)) {
				const updatedChecklist = { ...checklist }
				updatedChecklist.files = updatedChecklist.files.filter(file => file.id !== fileId)
				updatedChecklist.folders = updatedChecklist.folders?.filter(file => file.id !== fileId)
				setData(prev => ({ ...prev, checklist: updatedChecklist }))
			}
			trackActivity('CAMO', {
				event_type: 'Checklist File Unlinked',
				page_title: 'AMP Compliance',
				file_id: fileId || '',
				edited_form_id: editFormId || '',
				request_body: payload || ''
			})
		})
	}

	const onRemoveFile = (file) => {
		setData(prev => ({ ...prev, checklist: prev.checklist.filter(item => item.name !== file.name) }))
	}

	const onRemoveCamoFile = (file) => {
		setAttachments(prev => prev.filter(item => item.file_name !== file.file_name))
	}

	const onLinkFile = (file, linkUuid, type) => {
		if (type === "link" || linkUuid) {
			const folderUUID = [...(data.folder_uuid || []), linkUuid]
			const updatedChecklist = [...data.checklist, file]
			const uuidData = folderUUID.reduce((acc, arr) => acc.concat(arr), [])
			const output = updatedChecklist.reduce((acc, arr) => acc.concat(arr), [])
			setData(prev => ({ ...prev, checklist: output, folder_uuid: uuidData.join("") }))
		} else {
			onUpload(file)
		}
	}

	const onSubmitFileLink = (id) => {
		if (data?.checklist?.length > 0 && data.checklist.map(item => item.id).filter(item => item)) {
			let payload = {}
			if (data?.checklist.some(item => item.type === 'folder') && data?.checklist.some(item => item.type === 'file')) {
				payload.folder_ids = data.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',')
				payload.file_ids = data.checklist.filter(item => item.type === 'file').map(file => file.id).join(',')
			} else if (data?.checklist.some(item => item.type === 'folder')) {
				payload.folder_ids = data.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',')
			} else {
				payload.file_ids = data.checklist.filter(item => item.type === 'file').map(file => file.id).join(',')
			}
			globalPutService(`camo/repair/${id}/document-checklists/`, payload).then(response => {
				if (checkApiStatus(response)) {
					getResponseBack()
				} else {
					props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
				}
			})
		}
		if (data?.folder_uuid?.length > 0 && data.folder_uuid) {
			let formData = new FormData()
			formData.append('folder_uuid', data.folder_uuid)
			const fileItems = data.checklist.filter(item => item instanceof File)
			for (let i = 0; i < fileItems.length; i++) {
				formData.append('files[]', fileItems[i])
			}
			globalPutService(`camo/repair/${id}/document-checklists/`, formData).then(response => {
				if (checkApiStatus(response)) {
					getResponseBack()
				} else {
					props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
				}
			})
		}
	}

	return (
		<Fragment>
			<div id="AmpTaskForm">
				<div id="adTaskForm">
					<DialogTitle className="just-center">
						{formTitle}
						<CloseIcon
							onClick={() => { closeAddForm(); listResponseBack() }}
							className="close-icon"
						/>
					</DialogTitle>
					<form
						id="asset-form"
						onSubmit={(e) => handleSubmit(e, "add")}
					>
						<DialogContent>
							<Grid spacing={1} container id="ht-dropdown">
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										required={acumenCamo ? false : true}
										variant="outlined"
										label="ATA chapter"
										name="ata_chapter"
										id="ata_chapter"
										value={data.ata_chapter ? data.ata_chapter : ""}
										onChange={(e) => {
											const input = e.target.value
											if (input.length <= 20) {
												onFieldChange("ata_chapter", input)
												onRestErrorKey("ata_chapter")
											} else {
												e.preventDefault()
											}
										}}
										inputProps={{ maxLength: 15 }}
										error={acumenCamo ? false : error.ata_chapter ? true : false}
										helperText={acumenCamo ? "" : error.ata_chapter ? error.ata_chapter : ""}
										onFocus={() => onRestErrorKey("ata_chapter")}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										required
										variant="outlined"
										label="Repair Ref Number"
										name="repair_ref_number"
										id="repair_ref_number"
										value={data.repair_ref_number ? data.repair_ref_number : ""}
										onChange={(e) => {
											const input = e.target.value
											if (input.length <= 20) {
												onFieldChange("repair_ref_number", input)
												onRestErrorKey("repair_ref_number")
											} else {
												e.preventDefault()
											}
										}}
										InputLabelProps={{ shrink: true }}
										inputProps={{ maxLength: 25 }}
										error={error.repair_ref_number ? true : false}
										helperText={error.repair_ref_number ? error.repair_ref_number : ""}
										onFocus={() => onRestErrorKey("repair_ref_number")}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<Grid item>
										<FormControl>
											<InputLabel id="demo-simple-select-label">
												Repair Type
											</InputLabel>
											<Select
												labelId="repair_type"
												id="repair_type"
												name="repair_type"
												variant="outlined"
												value={data.repair_type}
												onChange={(e) => onFieldChange("repair_type", e.target.value)}
											>
												<MenuItem value={"DENT"}>Dent</MenuItem>
												<MenuItem value={"GOUGE"}>Gouge</MenuItem>
												<MenuItem value={"SCRATCH"}>Scratch</MenuItem>
												<MenuItem value={"CORROSION"}>Corrosion</MenuItem>
												<MenuItem value={"PAINT DAMAGE"}>Paint Damage</MenuItem>
												<MenuItem value={"CRACK"}>Crack</MenuItem>
												<MenuItem value={"SCRIBE LINR DAMAGE"}>Scribe Line Damage</MenuItem>
												<MenuItem value={"FOD"}>FOD</MenuItem>
												<MenuItem value={"CAT A"}>Cat A</MenuItem>
												<MenuItem value={"CAT B"}>Cat B</MenuItem>
												<MenuItem value={"CAT C"}>Cat C</MenuItem>
												<MenuItem value={"OTHERS"}>Others</MenuItem>
											</Select>
										</FormControl>
									</Grid>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										required={acumenCamo ? false : true}
										variant="outlined"
										label="Repair Compliance Ref"
										multiline
										name="repair_compliance_ref"
										id="repair_compliance_ref"
										value={data.repair_compliance_ref}
										error={acumenCamo ? false : error.repair_compliance_ref ? true : false}
										helperText={acumenCamo ? false : error.repair_compliance_ref ? error.repair_compliance_ref : ""}
										inputProps={{ maxLength: 255 }}
										onChange={(e) => onFieldChange("repair_compliance_ref", e.target.value)}
										InputLabelProps={{ shrink: true }}
										onFocus={() => onRestErrorKey("repair_compliance_ref")}
									/>
								</Grid>

								<Grid item md={12} sm={12} xs={12}>
									<TextField
										required={acumenCamo ? false : true}
										variant="outlined"
										label="Repair Description"
										name="repair_description"
										id="repair_description"
										multiline
										error={acumenCamo ? false : error.repair_description ? true : false}
										helperText={acumenCamo ? "" : error.repair_description ? error.repair_description : ""}
										value={data.repair_description ? data.repair_description : ""}
										onChange={(e) => {
											const input = e.target.value
											if (input.length <= 255) {
												onFieldChange("repair_description", input)
												onRestErrorKey("repair_description")
											} else {
												e.preventDefault()
											}
										}}
										InputLabelProps={{ shrink: true }}
										onFocus={() => onRestErrorKey("repair_description")}
									/>
								</Grid>
								<Grid item md={6} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="Repair Inspection"
										name="repair_inspection"
										id="repair_inspection"
										value={data.repair_inspection}
										error={error.repair_inspection ? true : false}
										helperText={error.repair_inspection ? error.repair_inspection : ""}
										onChange={(e) => {
											const input = e.target.value
											if (input.length <= 20) {
												onFieldChange("repair_inspection", input)
												onRestErrorKey("repair_inspection")
											} else {
												e.preventDefault()
											}
										}}
										InputLabelProps={{ shrink: true }}
										onFocus={() => onRestErrorKey("repair_inspection")}
									/>
								</Grid>

								<Grid item md={6} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="Repair Detail"
										name="repair_detail"
										id="repair_detail"
										value={data.repair_detail ? data.repair_detail : ""}
										onChange={(e) => {
											const input = e.target.value
											if (input.length <= 20) {
												onFieldChange("repair_detail", input)
												onRestErrorKey("repair_detail")
											} else {
												e.preventDefault()
											}
										}}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12} className="input-calender">
									<MuiPickersUtilsProvider utils={MomentUtils}>
										<KeyboardDatePicker
											id="repair_compliance_date"
											label="Repair compliance Date"
											format={acumenCamo ? fieldDMYShort : dayMonthDateFormat}
											inputVariant="outlined"
											fullWidth
											disableFuture
											InputLabelProps={{ shrink: true }}
											minDate={moment().subtract(25, "years")}
											value={data.repair_compliance_date}
											error={error.repair_compliance_date ? true : false}
											helperText={error.repair_compliance_date ? error.repair_compliance_date : ""}
											onFocus={() => onRestErrorKey("repair_compliance_date")}
											onChange={(dateVal) => {
												onFieldChange("repair_compliance_date", moment(dateVal).format(backendDateFormat))
												onRestErrorKey("repair_compliance_date")
											}}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="Repair location"
										name="repair_location"
										id="repair_location"
										value={data.repair_location}
										onChange={(e) => {
											const input = e.target.value
											if (input.length <= 20) {
												onFieldChange("repair_location", input)
												onRestErrorKey("repair_location")
											} else {
												e.preventDefault()
											}
										}}
										InputLabelProps={{ shrink: true }}
										onFocus={() => onRestErrorKey("repair_location")}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="Repair TSN"
										name="repair_compliance_tsn"
										id="repair_compliance_tsn"
										value={data.repair_compliance_tsn}
										onChange={(e) => {
											const input = e.target.value
											if (input.length <= 20) {
												onFieldChange("repair_compliance_tsn", input)
												onRestErrorKey("repair_compliance_tsn")
											} else {
												e.preventDefault()
											}
										}}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="Repair CSN"
										name="repair_compliance_csn"
										id="repair_compliance_csn"
										value={data.repair_compliance_csn}
										onChange={(e) => {
											const input = e.target.value
											if (input.length <= 20) {
												onFieldChange("repair_compliance_csn", input)
												onRestErrorKey("repair_compliance_csn")
											} else {
												e.preventDefault()
											}
										}}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
							</Grid>
							<div className="border-grey"></div>
							<Grid id="data-container" spacing={1} container>
								<Grid item md={3} sm={6} xs={12} className="input-calender">
									<label className="mb-10">LAST DONE</label>
									<MuiPickersUtilsProvider utils={MomentUtils}>
										<KeyboardDatePicker
											id="last_done_date"
											label="Date"
											format={acumenCamo ? fieldDMYShort : dayMonthDateFormat}
											inputVariant="outlined"
											fullWidth
											disableFuture
											InputLabelProps={{ shrink: true }}
											minDate={moment().subtract(25, "years")}
											value={data.last_done_date}
											error={error.last_done_date ? true : false}
											helperText={error.last_done_date ? error.last_done_date : ""}
											onFocus={() => onRestErrorKey("last_done_date")}
											onChange={(dateVal) => {
												onFieldChange("last_done_date", moment(dateVal).format(backendDateFormat))
												onRestErrorKey("last_done_date")
											}}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
								<Grid item md={3} sm={6} xs={12} id="lastdone-input">
									<TextField
										variant="outlined"
										label={<React.Fragment>Last Done FH</React.Fragment>}
										name="last_done_fh"
										id="last_done_fh"
										value={data.last_done_fh}
										error={error.last_done_fh ? true : false}
										helperText={error.last_done_fh ? error.last_done_fh : ""}
										onChange={(e) => {
											const input = e.target.value
											if (input.length <= 20) {
												onFieldChange("last_done_fh", input)
												onRestErrorKey("last_done_fh")
											} else {
												e.preventDefault()
											}
										}}
										InputLabelProps={{ shrink: true }}
										onFocus={() => onRestErrorKey("last_done_fh")}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12} id="lastdone-input">
									<TextField
										variant="outlined"
										label={<React.Fragment>Last Done FC</React.Fragment>}
										name="last_done_fc"
										id="last_done_fc"
										value={data.last_done_fc}
										error={error.last_done_fc ? true : false}
										helperText={error.last_done_fc ? error.last_done_fc : ""}
										onChange={(e) => {
											const input = e.target.value
											if (input.length <= 20) {
												onFieldChange("last_done_fc", input)
												onRestErrorKey("last_done_fc")
											} else {
												e.preventDefault()
											}
										}}
										InputLabelProps={{ shrink: true }}
										onFocus={() => onRestErrorKey("last_done_fc")}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12} id="ht-dropdown" className="repair-period">
									<FormControl>
										<InputLabel id="demo-simple-select-label" className="dropdown-label">
											Repair Status
										</InputLabel>
										<Select
											labelId="repair_status"
											name="repair_status"
											id="repair_status"
											error={error.repair_status ? true : false}
											helperText={error.repair_status ? error.repair_status : ""}
											variant="outlined"
											value={data.repair_status}
											onChange={(e) => onFieldChange("repair_status", e.target.value)}
										>
											<MenuItem value={"OPEN"}>OPEN</MenuItem>
											<MenuItem value={"CLOSED"}>CLOSED</MenuItem>
											<MenuItem value={"REPETITIVE"}>REPETITIVE</MenuItem>
										</Select>
									</FormControl>
								</Grid>
							</Grid>
							<Grid id="data-container" spacing={1} container>
								<Grid item md={3} sm={6} xs={12}>
									<label>INTERVAL</label>
									<Grid spacing={2} container id="ht-dropdown">
										<Grid item>
											<FormControl>
												<InputLabel id="demo-simple-select-label">Repair Compliance Period</InputLabel>
												<Select
													labelId="repair_interval_type"
													id="repair_interval_type"
													variant="outlined"
													value={data?.repair_interval_type}
													InputLabelProps={{ shrink: true }}
													onChange={(e) => onFieldChange("repair_interval_type", e.target.value)}
												>
													<MenuItem value={"D"}>Days</MenuItem>
													<MenuItem value={"FH"}>FH</MenuItem>
													<MenuItem value={"FC"}>FC</MenuItem>
													<MenuItem value={"FC,D"}>FC & D</MenuItem>
													<MenuItem value={"FH,D"}>FH & D</MenuItem>
													<MenuItem value={"FC,FH,D"}>FC,FH & D</MenuItem>
													<MenuItem value={"FC,FH"}>FC & FH</MenuItem>
												</Select>
											</FormControl>
										</Grid>
									</Grid>
								</Grid>
								{data.repair_interval_type == "FC" || data.repair_interval_type == "FC,D" || data.repair_interval_type == "FC,FH" || data.repair_interval_type == "FC,FH,D" ? <Grid item
									sm={6} xs={12}
									md={data.repair_interval_type == "FC" ? 3 : data.repair_interval_type == "FC,D" ? 2 : data.repair_interval_type == "FC,FH" ? 1 : data.repair_interval_type == "FC,FH,D" ? 1 : 3}
									id="dimensions-input-sr">
									<TextField
										variant="outlined"
										label={data.repair_interval_type == "FC" || data.repair_interval_type == "FC,D" || data.repair_interval_type == "FC,FH,D" || data.repair_interval_type == "FC,FH" ? "FC Interval" : "FC, Interval"}
										name="dimension_interval_fc"
										id="dimension_interval_fc"
										value={data.dimension_interval_fc}
										InputLabelProps={{ shrink: true }}
										onChange={(e) => onFieldChange("dimension_interval_fc", e.target.value)}
									/>
								</Grid> : null}
								{data.repair_interval_type == "FH" || data.repair_interval_type == "FH,D" || data.repair_interval_type == "FC,FH" || data.repair_interval_type == "FC,FH,D" ? <Grid item
									sm={6} xs={12} md={data.repair_interval_type == "FH" ? 3 : data.repair_interval_type == "FH,D" ? 2 : data.repair_interval_type == "FC,FH" ? 1 : data.repair_interval_type == "FC,FH,D" ? 1 : 3}
									id="dimensions-input-sr">
									<TextField
										variant="outlined"
										label={data.repair_interval_type == "FH" || data.repair_interval_type == "FH,D" || data.repair_interval_type == "FC,FH,D" || data.repair_interval_type == "FC,FH" ? "FH Interval" : "FH, Interval"}
										name="repair_interval"
										InputLabelProps={{ shrink: true }}
										id="repair_interval"
										value={data.repair_interval}
										onChange={(e) => onFieldChange("repair_interval", e.target.value)}
									/>
								</Grid> : null}
								{data.repair_interval_type == "D" || data.repair_interval_type == "FC,D" || data.repair_interval_type == "FH,D" || data.repair_interval_type == "FC,FH,D" ? (
									<Grid item
										sm={6} xs={12} md={data.repair_interval_type == "D" ? 3 : data.repair_interval_type == "FC,D" || data.repair_interval_type == "FH,D" ? 1 : data.repair_interval_type == "FC,FH,D" ? 1 : 3}
										id="dimensions-input-sr">
										<TextField
											label="Days"
											variant="outlined"
											name="dimension_interval_days"
											id="dimension_interval_days"
											value={data.dimension_interval_days}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => onFieldChange("dimension_interval_days", e.target.value)}
										/>
									</Grid>
								) : null}
								<Grid item md={3} sm={6} xs={12}>
									<label className="ml-10px font-14">REMAINING</label>
									<Grid spacing={1} container>
										<Grid className="remaining-input" item xs={6}>
											<TextField
												variant="outlined"
												label={data.repair_interval_type === "D" ? "Days" : data.repair_interval_type === "FC" ? "FC" : data.repair_interval_type === "FH" ? "FH" :
													data.repair_interval_type === "FH,D" ? "FH/Days" : data.repair_interval_type === "FC,D" ? "FC/Days" : data.repair_interval_type === "FC,FH,D" ? "FC/FH/Days" : data.repair_interval_type === "FC,FH" ? "FC/FH" : "Days"}
												name="remaining_val"
												id="remaining_val"
												value={remainingVal() ?? ''}
												onChange={(e) => onFieldChange("remaining_val", e.target.value)}
												inputProps={{ readOnly: true }}
												disabled
												className="disabled-input"
												InputLabelProps={{ shrink: true }}
											/>
										</Grid>
									</Grid>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<label className="ml-10px font-14">NEXT DUE </label>
									<Grid spacing={2} container>
										<Grid className="remaining-input" item xs={6}>
											<TextField
												variant="outlined"
												label={data.repair_interval_type === "D" ? "Date" : data.repair_interval_type === "FC" ? "FC" : data.repair_interval_type === "FH" ? "FH" : data.repair_interval_type === "FH,D" ? "FH/Date" :
													data.repair_interval_type === "FC,D" ? "FC/Date" : data.repair_interval_type === "FC,FH,D" ? "FC/FH/Date" : data.repair_interval_type === "FC,FH" ? "FC/FH " : "Date"}
												name="repair_DUE"
												id="repair_DUE"
												value={nextDueValue() ?? ""}
												onChange={(e) => onFieldChange("repair_DUE", e.target.value)}
												inputProps={{ readOnly: true }}
												disabled
												className="disabled-input"
												InputLabelProps={{ shrink: true }}
											/>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
							<div className="border-grey"></div>
							<Grid id="data-container" spacing={1} container>
								<Grid item md={3} sm={6} xs={12}>
									<label>D&B Compliance DFP</label>
									<FormControl
										error={error.dnb_compliance_dfp ? true : false}
										helperText={error.dnb_compliance_dfp ? error.dnb_compliance_dfp : ""}
										onFocus={() => onRestErrorKey("dnb_compliance_dfp")}
									>
										<RadioGroup
											required
											row
											aria-label="dnb_compliance_dfp"
											name="dnb_compliance_dfp"
											defaultValue="top"
											value={data.dnb_compliance_dfp}
											onChange={(e) => onFieldChange("dnb_compliance_dfp", e.target.value)}
										>
											<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
											<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
										</RadioGroup>
										{error.dnb_compliance_dfp && (
											<FormLabel component="dnb_compliance_dfp">
												<span style={{ color: "red" }}>{error.dnb_compliance_dfp}</span>
											</FormLabel>
										)}
									</FormControl>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<label>Release Certificate</label>
									<FormControl
										component="fieldset"
										error={error.release_certificate ? true : false}
										helperText={error.release_certificate ? error.release_certificate : ""}
									>
										<FormLabel component="legend"></FormLabel>
										<RadioGroup
											row
											aria-label="release_certificate"
											name="release_certificate"
											defaultValue="top"
											value={data.release_certificate}
											onChange={(e) => onFieldChange("release_certificate", e.target.value)}
										>
											<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
											<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
										</RadioGroup>
										{error.release_certificate && (
											<FormLabel component="release_certificate">
												<span style={{ color: "red" }}>{error.release_certificate}</span>
											</FormLabel>
										)}
									</FormControl>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<label>Certificate of Conformity</label>
									<FormControl
										component="fieldset"
										error={error.certificate_of_conformity ? true : false}
										helperText={error.certificate_of_conformity ? error.certificate_of_conformity : ""}
									>
										<FormLabel component="legend"></FormLabel>
										<RadioGroup
											row
											aria-label="certificate_of_conformity"
											name="certificate_of_conformity"
											defaultValue="top"
											value={data.certificate_of_conformity}
											onChange={(e) => onFieldChange("certificate_of_conformity", e.target.value)}
										>
											<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
											<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
											<FormControlLabel value="N/A" control={<Radio size="small" color="primary" />} label="N/A" />
										</RadioGroup>
										{error.certificate_of_conformity && (
											<FormLabel component="certificate_of_conformity">
												<span style={{ color: "red" }}>{error.certificate_of_conformity}</span>
											</FormLabel>
										)}
									</FormControl>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<label>SRM reference Documents {acumenCamo ? false : <span style={{ color: "red" }}>*</span>}</label>
									<FormControl
										error={error.srm_ref_document ? true : false}
										helperText={error.srm_ref_document ? error.srm_ref_document : ""}
										onFocus={() => onRestErrorKey("srm_ref_document")}
									>
										<RadioGroup
											required
											row
											aria-label="srm_ref_document"
											name="srm_ref_document"
											defaultValue="top"
											value={data.srm_ref_document}
											onChange={(e) => onFieldChange("srm_ref_document", e.target.value)}
											onBlur={() => onFocusValidation("srm_ref_document")}
										>
											<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
											<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
											<FormControlLabel value="N/A" control={<Radio size="small" color="primary" />} label="N/A" />
										</RadioGroup>
										{error.srm_ref_document && (
											<FormLabel component="srm_ref_document">
												<span style={{ color: "red" }}>{error.srm_ref_document}</span>
											</FormLabel>
										)}
									</FormControl>
								</Grid>
							</Grid>
							<Grid id="data-container" spacing={1} container>
								<Grid item md={3} sm={6} xs={12}>
									<label>OEM Repair Scheme</label>
									<FormControl
										component="fieldset"
										error={error.oem_repair_scheme ? true : false}
										helperText={error.oem_repair_scheme ? error.oem_repair_scheme : ""}
									>
										<FormLabel component="legend"></FormLabel>
										<RadioGroup
											row
											aria-label="oem_repair_scheme"
											name="oem_repair_scheme"
											defaultValue="top"
											value={data.oem_repair_scheme}
											onChange={(e) => onFieldChange("oem_repair_scheme", e.target.value)}
										>
											<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
											<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
											<FormControlLabel value="N/A" control={<Radio size="small" color="primary" />} label="N/A" />
										</RadioGroup>
										{error.oem_repair_scheme && (
											<FormLabel component="oem_repair_scheme">
												<span style={{ color: "red" }}> {error.oem_repair_scheme} </span>
											</FormLabel>
										)}
									</FormControl>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<label>FAA 8100-9 / Equivalent</label>
									<FormControl
										component="fieldset"
										error={error.faa_equivalent ? true : false}
										helperText={error.faa_equivalent ? error.faa_equivalent : ""}
									>
										<FormLabel component="legend"></FormLabel>
										<RadioGroup
											row
											aria-label="faa_equivalent"
											name="faa_equivalent"
											defaultValue="top"
											value={data.faa_equivalent}
											onChange={(e) => onFieldChange("faa_equivalent", e.target.value)}
										>
											<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
											<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
											<FormControlLabel value="N/A" control={<Radio size="small" color="primary" />} label="N/A" />
										</RadioGroup>
										{error.faa_equivalent && (
											<FormLabel component="faa_equivalent">
												<span style={{ color: "red" }}> {error.faa_equivalent} </span>
											</FormLabel>
										)}
									</FormControl>
								</Grid>
							</Grid>
							<Grid spacing={1} container>
								<Grid item md={6} sm={12} xs={12}>
									<TextField
										label="Remark"
										margin='normal'
										variant='outlined'
										fullWidth
										value={data?.remark || ''}
										InputLabelProps={{ shrink: true }}
										onChange={(e) => onFieldChange("remark", e.target.value)}
										rows={3}
										multiline
										inputProps={{ maxLength: 250 }}
									/>
								</Grid>
								<Grid item md={6} sm={12} xs={12}>
									<div className="upload-amp-textbox" style={{ border: "1px solid gray", textAlign: 'center' }}>
										<ul className="list-inline spacing-list">
											<li className="list-inline-item" onClick={() => setUploadFile(true)}>
												<span className="flex-centered"><AttachmentIcon color='primary' fontSize='small' /> Upload File</span>
											</li>
											<li className="list-inline-item" onClick={() => setLinkFile(true)}>
												<span className="flex-centered"><LinkIcon color='primary' fontSize='small' />Link file from Records Module</span>
											</li>
										</ul>
									</div>
								</Grid>
							</Grid>
							<Grid id="data-container" spacing={1} container>
								<Grid spacing={1} container>
									{actionType === 'add' ?
										<div className='checklist-files'>
											<ul className='list-inline'>
												{data?.checklist?.map((file) =>
													<li className='list-inline-item'>
														<span className='file-name'>{file.name}</span>
														<span className='file-remove'>
															<a href={decodeURIComponent(file.path)} download={file.name}><GetAppIcon color="primary" /></a>
															<CloseIcon onClick={() => onRemoveFile(file)} color='secondary' fontSize='small' />
														</span>
													</li>
												)}
												{attachments?.map((attachment) =>
													<li className='list-inline-item'>
														<span className='file-name'>{attachment.file_name}</span>
														<span className='file-remove'>
															<a href={decodeURIComponent(attachment.file)} download={attachment.file_name}><GetAppIcon color="primary" /></a>
															<CloseIcon onClick={() => onRemoveCamoFile(attachment)} color='secondary' fontSize='small' />
														</span>
													</li>
												)}
											</ul>
										</div>
										:
										<div className='checklist-files'>
											<ul className='list-inline'>
												{data?.checklist?.files?.map((file) =>
													<li className='list-inline-item'>
														<span className='file-name'>{file.name}</span>
														<span className='file-remove'>
															<a href={decodeURIComponent(file.path)} download={file.name}><GetAppIcon color="primary" /></a>
															<CloseIcon onClick={() => onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
														</span>
													</li>
												)}
												{(data.checklist?.folders?.length > 0) &&
													data.checklist?.folders.map((file) => (
														<li className='list-inline-item' key={file.id}>
															<Tooltip title={`Records Data Room :- ${file?.location}`} arrow>
																<a href={`${config.domain.records}${assetType[props.props?.match.params.assetType]}/${file?.asset_slug}/data-room/technical/${file?.uuid}`} target="_new">
																	<img style={{ width: '15px', float: 'right', marginRight: '-18px', marginTop: '7px' }} src={imgStoragePath + 'phase-2/RecordsIcon.svg'} alt="Records Data Room" />
																</a>
															</Tooltip>
															<span className='file-name'>{file.name}</span>
															<span className='file-remove'>
																<CloseIcon onClick={() => onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
															</span>
														</li>
													))}
												{attachments?.map((attachment) =>
													<li className='list-inline-item'>
														<span className='file-name'>{attachment.file_name}</span>
														<span className='file-remove'>
															<a href={decodeURIComponent(attachment.file)} download={attachment.file_name}><GetAppIcon color="primary" /></a>
															<CloseIcon onClick={() => deleteAttachmentFile(attachment.id, attachment)} color='secondary' fontSize='small' />
														</span>
													</li>
												)}
											</ul>
										</div>}
								</Grid>
							</Grid>
						</DialogContent>
						<DialogActions className="actions-btn">
							<Button type="button" className="btn btn-primary" onClick={(e) => handleSubmit(e, "add")}>
								{actionType === "add" ? "Add" : "Update"}
							</Button>
							{actionType === "add" ? (
								<Button onClick={(e) => saveAndAddAnother(e)} type="button" className="btn btn-primary">Save & Add Another</Button>
							) : ""}
							<Button type="button" className="btn btn-primary" onClick={() => { closeAddForm(); listResponseBack() }}>Close</Button>
						</DialogActions>
						<Dialog open={linkFile} onClose={() => setLinkFile(false)} id="htDialog">
							<LinkFiles
								handleClose={() => setLinkFile(false)}
								uuid={uuid?.uuid}
								editFormId={editFormId}
								getResponseBack={(file) => getResponseBackFn(file)}
								listResponseBack={(file) => listResponseBack(file)}
								actionType={actionType}
								onLinkFile={(file, any, type) => onLinkFile(file, any, type)}
								modType="repair"
								last_used_folder_uuid={last_used_folder_uuid_link_document}
								uploadFileInfo={data}
								attachments={attachments}
								type="link"
							/>
						</Dialog>
						<Dialog open={uploadFile} onClose={() => setUploadFile(false)} id="htDialog">
							<UploadFile
								handleClose={() => setUploadFile(false)}
								uuid={uuid?.uuid}
								editFormId={editFormId}
								getResponseBack={(file) => getResponseBackFn(file)}
								listResponseBack={(file) => listResponseBack(file)}
								actionType={actionType}
								onLinkFile={(file, linkUuid) => onLinkFile(file, linkUuid)}
								modType="repair"
								uploadFileInfo={data}
								last_used_folder_uuid={last_used_folder_uuid}
								onUpload={(file) => onUpload(file)}
								type="upload"
								checkbox_last_used_folder_uuid={checkbox_last_used_folder_uuid}
								checkbox_last_used_folder_name={checkbox_last_used_folder_name}
							/>
						</Dialog>
					</form>
				</div>
			</div>
		</Fragment>
	)
}

export default SrTaskForm
